import React, { useState, useContext, useMemo } from 'react'

import { RestaurantContext } from '../RestaurantDesignerHandler'
import Card from 'components/Card'
import { CardHeader, MainContainer, MainInnerContainer } from 'components/Tree/nodes/common'

const Project = ({ children, label, cardsInRow, isSelectable, handleSelect, inverted, id }) => {
	const { currentProjectIds } = useContext(RestaurantContext)
	const [isActive, setActive] = useState(currentProjectIds.projectId === id)
	useMemo(()=>setActive(currentProjectIds.projectId === id), [currentProjectIds.projectId])
	return (
		<MainContainer xs={Math.ceil(12 / cardsInRow)}>
			<Card
				BodyComponent={props => <MainInnerContainer inverted={inverted} {...props}/>}
				HeaderComponent={headerProps => (
					<CardHeader onClick={handleSelect} isSelected={isActive} isSelectable={isSelectable} {...headerProps}>
						{label}
					</CardHeader>
				)}
				label={label}
			>
				{children}
			</Card>
		</MainContainer>
	)
}


export default Project
